import type { RevenueBreakdown } from '@weft/types';
import { formatNumber } from '@weft/utils';
import React from 'react';

type InvoiceSummaryProps = {
  revenueBreakdown: RevenueBreakdown;
  currencySymbol: string;
};

export const InvoiceSummary:React.FC<InvoiceSummaryProps> = ({
  revenueBreakdown,
  currencySymbol,
}) => {
  return (
    <div className='rounded-2lg border-line border px-5'>
      <div className="border-b-line border-b py-5">
        <div className="space-y-3.5">
          <div className="flex items-center justify-between text-base text-black">
            <div>Sub Total</div>
            <div>{`${currencySymbol + formatNumber(revenueBreakdown.subtotal)}`}</div>
          </div>
          <div className="flex items-center justify-between text-base text-black">
            <div>Tax</div>
            <div>{`${currencySymbol + formatNumber(revenueBreakdown.tax)}`}</div>
          </div>
          <div className="flex items-center justify-between text-base text-black">
            <div>Promotions</div>
            <div>{`-${currencySymbol + formatNumber(revenueBreakdown.discount)}`}</div>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-between py-4">
        <div className="text-xl font-bold text-black">Amount Due</div>
        <div className='text-xl font-bold text-black'>
          <span className='text-base font-medium'>{currencySymbol}</span>
          {formatNumber(revenueBreakdown.total)}
        </div>
      </div>
    </div>
  );
};